import React from 'react'

const ITEMS = [
    { key: "magia-1",   text: "Magia Musical" },
    { key: "eventos-1", text: "Nuevos Eventos" },
    { key: "magia-2",   text: "Magia Musical" },
    { key: "eventos-2", text: "Nuevos Eventos" },
]

export default function Slider() {
    return (
        <div className='bg-[#121212]'>
            <section className="sliding-text-one" aria-hidden="true">
                <div className="sliding-text-one__wrap h-[120px]">
                    <ul className="sliding-text__list marquee_mode">
                        {[...ITEMS, ...ITEMS].map((item, i) => (
                            <li key={`${item.key}-${i}`}>
                                <h2 data-hover={item.text} className="sliding-text__title">
                                    {item.text}
                                    <img src="/identity/LOGO_SHORT.png" className='h-[25px] rounded-full' alt="Logo" />
                                </h2>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>
        </div>
    )
}
